import { Component, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit } from '@angular/core';
import { VideoRepositoryService } from '../../services/video-repository.service';
import { DwButtonConfig, DwModalConfig, DwModalHandler, DwModalResult } from '@devwareapps/devware-cap';
import { forkJoin, Observable, of, Subscription } from 'rxjs';
import { VideoEntity } from '../../../../meta-data/app-meta-data.service';
import { VideoPreviewPlayback } from '../../models/video-playback.model';

@Component({
  selector: 'app-video-modal',
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.scss']
})
export class VideoModalComponent implements OnInit, OnDestroy, DwModalHandler {
  video: VideoEntity;
  videoPlayback: VideoPreviewPlayback;
  videoModalStyle: any = {};
  private previewSubscription: Subscription;

  constructor(private videoRepository: VideoRepositoryService, private elementRef: ElementRef) { }
  modalConfig: DwModalConfig<any>;
  closeModal: EventEmitter<DwModalResult<any>>;

  aspectRating: number = 16 / 9;

  buttonClick(buttonConfig: DwButtonConfig): Observable<DwModalResult> {
    let result = new DwModalResult();

    result.closeModal = true;

    return of(result);
  }

  ngOnInit(): void {
    const videoId = Number(this.modalConfig.data);
    this.setupModalStyle();

    if (!Number.isFinite(videoId) || videoId < 1) {
      return;
    }

    this.previewSubscription = forkJoin([
      this.videoRepository.getVideos([videoId]),
      this.videoRepository.getVideoPreviewPlayback(videoId)
    ]).subscribe(
      ([videos, playback]) => {
        if (videos.length > 0) {
          this.video = videos[0];
          this.videoPlayback = playback;
        }
      },
      () => {
        this.video = null;
        this.videoPlayback = null;
      });
  }

  ngOnDestroy(): void {
    this.previewSubscription?.unsubscribe();
  }


  @HostListener('window:resize', ['$event'])
  public reset(event: any): void {
    // re-configure the grid style upon browser resize
    this.setupModalStyle();
  }

  setupModalStyle() {
    // if (!this.elementRef?.nativeElement) {
    //   return;
    // }

    const maxWidth = window.innerWidth;
    const maxHeight = window.innerHeight;

    let width = maxWidth - 100;

    if (width < 450) {
      width = maxWidth - 51;
    }

    if (width > 1200) {
      width = 1200;
    }

    let height = width / this.aspectRating;

    if (height > maxHeight) {
      height = maxHeight - 100;
      width = height * this.aspectRating;
    }

    this.videoModalStyle['width'] = width + 'px';
    this.videoModalStyle['height'] = height + 'px';
  }

}
